var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProduct(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CDD0D4",
    d: "M12.54 3.239l6.18 3.067c.395.196.708.478.937.845.229.367.343.771.343 1.212v7.292c0 .44-.114.845-.343 1.212a2.264 2.264 0 0 1-.938.845l-6.18 3.05c-.321.158-.668.238-1.039.238-.371 0-.718-.08-1.04-.239l-6.198-3.067a2.273 2.273 0 0 1-.919-.854A2.262 2.262 0 0 1 3 15.637V8.363c0-.44.114-.845.343-1.212.23-.367.542-.649.938-.845l6.18-3.067c.321-.16.668-.239 1.039-.239.371 0 .718.08 1.04.239z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#74797D",
    d: "M12.54 3.239l6.18 3.067c.395.196.708.478.937.845.229.367.343.771.343 1.212v7.292c0 .44-.114.845-.343 1.212a2.264 2.264 0 0 1-.938.845l-6.18 3.05c-.321.158-.668.238-1.039.238-.371 0-.718-.08-1.04-.239l-6.198-3.067a2.273 2.273 0 0 1-.919-.854A2.262 2.262 0 0 1 3 15.637V8.363c0-.44.114-.845.343-1.212.23-.367.542-.649.938-.845l6.18-3.067c.321-.16.668-.239 1.039-.239.371 0 .718.08 1.04.239zm4.955 4.17l-5.642-2.793a.754.754 0 0 0-.687 0l-1.8.882 5.994 2.975 2.135-1.065zm.965 1.23l-2.747 1.359v.018l-3.434 1.69v7.476l5.754-2.847a.773.773 0 0 0 .427-.68V8.64zm-7.74 10.543v-7.476L4.54 8.64v7.016c0 .135.04.266.121.395.08.129.183.223.306.285l5.754 2.847zM7.64 6.342L5.505 7.409l5.995 2.976 2.134-1.066L7.64 6.343z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.5455de66083f9227c17afb3b85b3b093.svg";
export { ForwardRef as ReactComponent };